import { Link } from "react-router-dom";
import FlipbookViewer from "../components/FlipbookViewer";

export default function IngroundPools() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">IN-GROUND POOL</h1>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-3xl font-bold text-gray-900">Our In-Ground Pool Installation Process</h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            {/* Left - Text */}
            <div>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
                At ATLAS PRO SERVICES LLC, every project begins with an on-site visit to meet with the homeowners. During this initial consultation, we'll discuss your vision, needs, and goals for creating the perfect backyard pool experience. Together, we'll explore options for pool shape and size, as well as select the right equipment and sanitation solutions. From filters and sanitization systems to heaters, heat pumps, and lighting, we'll guide you through all the possibilities. We'll also handle all necessary permits, so you can focus on planning your dream pool.
              </p>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
                Once the planning is complete, we'll take care of every step of the construction process. From excavation and building to backfilling, plumbing, and electrical work, our team ensures everything is done with precision and care. We'll also walk you through concrete finishing options to create the perfect look for your pool area. Throughout the entire project, ATLAS PRO SERVICES LLC will maintain open communication, keeping you informed at every phase.
              </p>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
                When your pool is ready, we'll provide a comprehensive "Pool 101" class. During this session, we'll teach you how to operate and maintain your pool, covering all its features and functions. We'll answer any questions you have, both during this session and anytime in the future.
              </p>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6">
                At ATLAS PRO SERVICES LLC, we take the stress out of building your pool, so you can focus on enjoying a stunning backyard retreat that will bring joy for years to come.
              </p>

              <Link
                to="/contact"
                className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-md text-sm transition-colors whitespace-nowrap"
              >
                Contact Us
              </Link>
            </div>

            {/* Right - Image */}
            <div>
              <img
                              src="/images/iStock-121956779-1.jpg"
                alt="In-Ground Installations"
                className="w-full h-auto rounded-lg border border-gray-200"
                width={732}
                height={1011}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Brochure Section */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <p className="text-sm md:text-base text-gray-700 mb-8">Check out the new Brochure below!</p>
        </div>
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <FlipbookViewer
            title="2025 Structural Armor Master Brochure"
                      downloadUrl="/images/2025_Structural_Armor_Master_compressed-1.pdf"
          />
        </div>
      </section>
    </div>
  );
}